(() => {
  const animationTime = 200;
  let animationState = 'invisible';
  let isShowing = false;

  const replaceAll = (str, find, replace) => str.split(find).join(replace);
  const removeAll = (str, toRemove) => str.split(find).join('');
  const splitBy = (str, split1, split2) => replaceAll(str, split1, split2).split(split2);
  const sleep = (time) => new Promise((resolve, reject) => setTimeout(resolve, time));

  const getPosition = (elem, tooltip, settings={}) => {
    const pos = elem.getBoundingClientRect();
    const ttPos = tooltip.getBoundingClientRect()
    const ttCenter = ttPos.width / 2;

    let left = pos.right + window.scrollX;
    left -= pos.width / 2;
    left -= ttCenter;

    if (settings.direction === 'right')
      left += (ttPos.width / 2) + (pos.width / 2);
    if (settings.direction === 'left')
      left -= (ttPos.width / 2) + (pos.width / 2);

    left += (parseInt(settings.offsetLeft) || 0);

    const offsetTop = settings.offsetTop || 0;
    let top = pos.top + window.scrollY;
    if (settings.direction === 'below')
      top += pos.height;
    if (settings.direction === 'above')
      top -= pos.height - (ttPos.height * 0.9);
    if (settings.direction === 'left' || settings.direction === 'right')
      top += ttPos.height / 2;

    top += (parseInt(settings.offsetTop) || 0);

    return { left: left + 'px', top: top + 'px' };
  };

  const setTooltipPosition = (elem, tooltip, settings={}) => {
    const pos = getPosition(elem, tooltip, settings);
    tooltip.style.left = pos.left;
    tooltip.style.top = pos.top;
  }

  const setTooltipContent = (elem, tooltip, settings={}) => {
    const dir = settings.direction;
    const bg = settings.background;

    ['above', 'below', 'left', 'right'].forEach(d => {
      tooltip.classList[d === dir ? 'add' : 'remove'](d);
    });

    const rawContent =  elem.getAttribute('data-tl-tooltip');
    const arrow = tooltip.querySelector('.tl-arrow');
    const colored = (d) => d === dir ? bg : 'transparent';
    arrow.style.setProperty(`border-color`, ['above', 'right', 'below', 'left'].map(colored).join(' '));

    const contentBox = tooltip.querySelector('.tl-content');
    const s = contentBox.style;
    s.background = bg;
    s.color = settings.color;
    s.border = settings.bordered ? '2px solid ' + settings.borderColor : 'none';
    s.fontSize = settings.fontSize.toString() + 'px';
    s.animationTime = animationTime + 'ms';
    let content = replaceAll(rawContent, '\\n', '<br>');
    content = content.replace(/i:([\w\d]+)/, '<i class="lnr-$1 tl-tt-icon"></i>');
    contentBox.innerHTML = content;
  };

  const parseSettings = (settingsString, defaultSettings={}) => {
    const specialValues = {
      'tlbrown': '#534536',
      'tlorange': '#204623'
    };
    const settings = {};

    if (settingsString) {
      const pairs = splitBy(settingsString, ', ', ',');

      for (const pair of pairs) {
        const [key, value] = splitBy(pair, ': ', ':');
        settings[key] = value;

        if (value === 'true' || value === 'false')
          settings[key] = value === 'true';

        if (Object.keys(specialValues).includes(value))
          settings[key] = specialValues[value];
      }
    }

    for (const key in defaultSettings) {
      const value = defaultSettings[key];

      if (!settings[key]) {
        settings[key] = defaultSettings[key];

        if (Object.keys(specialValues).includes(value))
          settings[key] = specialValues[value];
      }
    }

    return settings;
  };

  const showTooltip = async ({target: elem}, tooltip) => {
    if (animationState === 'fading-out') await sleep(animationTime);
    isShowing = true;
    animationState = 'fading-in';
    tooltip.classList.remove('d-none');

    const defaultSettings = {
      direction: 'above',
      color: 'white',
      background: 'tlbrown',
      bordered: false,
      borderColor: 'black',
      fontSize: 11
    };

    const settings = parseSettings(elem.getAttribute('data-tl-tooltip-settings'), defaultSettings);
    setTooltipContent(elem, tooltip, settings);
    setTooltipPosition(elem, tooltip, settings);

    tooltip.classList.add('tl-fade-in');
    setTimeout(() => {
      animationState = 'visible';
      tooltip.classList.remove('tl-fade-in');
    }, animationTime);
  };

  const hideTooltip = async ({target: elem}, tooltip) => {
    if (animationState === 'fading-in') await sleep(animationTime);
    isShowing = false;
    animationState = 'fading-out';
    tooltip.classList.add('tl-fade-out');
    setTimeout(() => {
      animationState = 'invisible';
      tooltip.classList.remove('tl-fade-out');
      tooltip.classList.add('d-none');
    }, animationTime);
  };

  const initTooltip = (elem) => {
    if (elem.classList.contains('tl-tooltip-item')) return;
    elem.classList.add('tl-tooltip-item');

    const tooltip = document.querySelector('.tl-tooltip');
    elem.removeAttribute('title');
    elem.addEventListener('mouseenter', (event) => showTooltip(event, tooltip));
    elem.addEventListener('mouseleave', (event) => hideTooltip(event, tooltip));
  };

  const init = (() => {
    const tooltipElements = [...document.querySelectorAll('[data-tl-tooltip]')];
    tooltipElements.forEach(initTooltip);

    setInterval(() => {
      const tooltipElements = [...document.querySelectorAll('[data-tl-tooltip]')];
      tooltipElements.forEach(initTooltip);
    }, 1000);
  })();

})();
